import cn from 'classnames';
import React from 'react';
import { Button, ButtonProps } from '@react-md/button';
import { TextIconSpacing } from '@react-md/icon';
import { CircularProgress } from '@react-md/progress';
import { FeatureContent } from '@components/feature-content';

import styles from './counter-button.module.scss';
import { composeNodeId } from '@utils';

type CounterButtonProps = ButtonProps & { id: string; count: string; isSending?: boolean };

export const CounterButton: React.FC<CounterButtonProps> = ({ id, count, isSending = false, children, ...rest }) => {
    return (
        <FeatureContent
            contentKey={id}
            fallback={children}
            wrapper={props => {
                const content = (
                    <TextIconSpacing
                        icon={
                            <div
                                className={cn(styles.counter, {
                                    [styles.counterBig]: count.length > 2,
                                })}
                                data-place={count}
                            />
                        }
                        iconAfter
                        forceIconWrap
                    >
                        {props.children}
                    </TextIconSpacing>
                );

                return (
                    <Button
                        type="button"
                        className={cn(['rmd-button--text-large', styles.btn, rest.className])}
                        {...props}
                        {...rest}
                    >
                        {isSending ? (
                            <TextIconSpacing
                                className="rmd-toggle--progress-submit"
                                icon={
                                    <CircularProgress id={composeNodeId(props.id, 'progress')} centered={false} small />
                                }
                            >
                                {content}
                            </TextIconSpacing>
                        ) : (
                            content
                        )}
                    </Button>
                );
            }}
        />
    );
};

CounterButton.defaultProps = {
    theme: 'primary',
    themeType: 'contained',
};
